import { CareerEventsCarousel } from '@/features/CareerEventsCarousel';
import { generateStyleModifiers } from '@/utils/generateStyleModifiers';

const IntegrationCareerEvents = (props) => {
    const modifiers = generateStyleModifiers(props.appliedCssClassNames);
    const theme = modifiers.theme;

    return <CareerEventsCarousel {...props} theme={theme} isInEditor={props.isInEditor} />;
};

export default IntegrationCareerEvents;
